<template>
  <pict
    class="format-banner-blinks-image__image"
    block-name="format-banner-blinks-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageLEN from "./images/blinks-desktop-en.png"
import imageL2xEN from "./images/blinks-desktop-en@2x.png"
import imageMEN from "./images/blinks-tablet-en.png"
import imageM2xEN from "./images/blinks-tablet-en@2x.png"
import imageSEN from "./images/blinks-mobile-en.png"
import imageS2xEN from "./images/blinks-mobile-en@2x.png"
import imageLDE from "./images/blinks-desktop-de.png"
import imageL2xDE from "./images/blinks-desktop-de@2x.png"
import imageMDE from "./images/blinks-tablet-de.png"
import imageM2xDE from "./images/blinks-tablet-de@2x.png"
import imageSDE from "./images/blinks-mobile-de.png"
import imageS2xDE from "./images/blinks-mobile-de@2x.png"

export default {
  name: "FormatBannerBlinksImage",
  components: {
    Pict
  },
  computed: {
    useDEImages() {
      return this.$i18n.locale === "de"
    },
    imageProps() {
      return {
        default: {
          src: this.useDEImages ? imageLDE : imageLEN,
          srcset: {
            "2x": this.useDEImages ? imageL2xDE : imageL2xEN
          }
        },
        sources: [
          {
            media: "s",
            src: this.useDEImages ? imageSDE : imageSEN,
            srcset: {
              "2x": this.useDEImages ? imageS2xDE : imageS2xEN
            }
          },
          {
            media: "m",
            src: this.useDEImages ? imageMDE : imageMEN,
            srcset: {
              "2x": this.useDEImages ? imageM2xDE : imageM2xEN
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Some Blinks Covers"
      },
      de: {
        alt: "Einige Blinks Cover"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.format-banner-blinks-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
